import { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Package2, Pill, Sparkles, ArrowRight, ShieldCheck } from "lucide-react";
import api from "@/lib/api";

const fmt = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");
const fmtDay = (iso) => { try { return new Date(iso).toLocaleString([], { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

export default function OrderConfirmation() {
  const { oid } = useParams();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const isDemo = params.get("demo") === "1";
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/me/orders/${oid}`).then((r) => setOrder(r.data.order)).catch(() => setOrder(null));
  }, [oid]);

  if (!order) return <div className="ck-wrap"><p className="lead">Loading…</p></div>;

  return (
    <div className="ck-wrap" data-testid="order-confirmation">
      <section className="ord-banner">
        <CheckCircle2 size={36} />
        <div>
          <h1>Order placed</h1>
          <p>
            We&apos;ve received your order. {isDemo
              ? "This is a demo checkout — once Razorpay keys are configured, real payment will be required."
              : "A confirmation email will reach you shortly."}
          </p>
        </div>
      </section>

      <div className="ord-grid">
        <section className="ord-panel">
          <div className="ord-head">
            <h2>Order #{order.id.slice(-8).toUpperCase()}</h2>
            <small>{fmtDay(order.created_at)}</small>
          </div>
          <ul className="ord-items">
            {order.items.map((it, i) => {
              const Ic = it.kind === "pharmaceutical" ? Pill : Sparkles;
              return (
                <li key={i}>
                  <div className="ck-thumb">{it.image_url ? <img src={it.image_url} alt="" /> : <Ic size={18} />}</div>
                  <div className="ck-i-meta"><b>{it.name}</b><small>Qty {it.qty}{it.rx_required && " · Rx"}</small></div>
                  <span className="ck-i-price">{fmt(it.line_total)}</span>
                </li>
              );
            })}
          </ul>
          <div className="ck-sum-rows">
            <div><span>Subtotal</span><b>{fmt(order.subtotal)}</b></div>
            <div><span>Shipping</span><b>{fmt(order.shipping_fee)}</b></div>
            <div className="total"><span>Total paid</span><b>{fmt(order.total_amount)}</b></div>
          </div>
          <span className="ord-status">
            <Package2 size={13} /> Status: <b>{(order.status || "").replace(/_/g, " ")}</b>
          </span>
        </section>

        <aside className="ord-panel">
          <h3>Ship to</h3>
          <p className="ord-addr">
            <b>{order.shipping.full_name}</b><br />
            {order.shipping.line1}{order.shipping.line2 && <>, {order.shipping.line2}</>}<br />
            {order.shipping.city}, {order.shipping.state} — {order.shipping.pincode}<br />
            <small>{order.shipping.phone}</small>
          </p>
          <button className="pg-btn pg-btn-ink full" onClick={() => nav("/b2b/orders")} data-testid="ord-view-orders">
            View my orders <ArrowRight size={14} />
          </button>
          <p className="ck-muted small" style={{ marginTop: 12 }}><ShieldCheck size={11} /> Order ID: {order.id}</p>
        </aside>
      </div>
    </div>
  );
}
